import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserModel} from '../../../services/user/user.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngxs/store';
import {Subscription} from 'rxjs';
import {MustMatch} from '../../../validators/mustMatch.validator';
import {ValidateUserNameNotTaken} from '../../../validators/usernameNotTaken.validator';
import {UserService} from '../../../services/user/user.service';
import {UpdateCurrentUser, UpdateCurrentUserPassword, UserLogout} from '../../../../state/actions/appState.account.actions';

@Component({
  selector: 'app-account-settings-modal',
  templateUrl: './account-settings.modal.component.html',
  styleUrls: ['./account-settings.modal.component.scss']
})
export class AccountSettingsModalComponent implements OnInit, OnDestroy {
  @Input() user: UserModel;

  passwordForm: FormGroup;
  informationForm: FormGroup;

  private subs: Subscription[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private store: Store,
    private cd: ChangeDetectorRef,
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.passwordForm = this.fb.group({
      password: new FormControl(
        '', [Validators.required, Validators.minLength(5)]),
      repeat: new FormControl(
        '', [Validators.required])
    }, {
      validator: MustMatch('password', 'repeat')
    });
    this.subs.push(
      this.passwordForm.valueChanges.subscribe(() => {
        this.cd.detectChanges();
      })
    );

    this.informationForm = this.fb.group({
      userName: new FormControl(
        this.user ? this.user.userName : '', [Validators.required],
        [ValidateUserNameNotTaken.validate(this.userService, [this.user.userName])]),
      firstName: new FormControl(
        this.user ? this.user.firstName : '', [Validators.required]),
      lastName: new FormControl(
        this.user ? this.user.lastName : '', [Validators.required])
    });
    this.subs.push(
      this.informationForm.valueChanges.subscribe(() => {
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  closeModal() {
    this.activeModal.close(this.user);
  }

  logout() {
    this.store.dispatch(new UserLogout());
  }

  submitPassword() {
    this.store.dispatch(new UpdateCurrentUserPassword(this.passwordForm.getRawValue()));
  }

  submitInformation() {
    const {userName, firstName, lastName} = this.informationForm.getRawValue();
    this.store.dispatch(new UpdateCurrentUser({
        userName,
        firstName,
        lastName,
        admin: this.user.admin
      })
    );
  }
}
